import { render, staticRenderFns } from "./AcceptPage.vue?vue&type=template&id=43ab44e6&scoped=true"
import script from "./AcceptPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AcceptPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ab44e6",
  null
  
)

export default component.exports